import { render, staticRenderFns } from "./error-book.vue?vue&type=template&id=ec134438&scoped=true&"
import script from "./error-book.vue?vue&type=script&lang=js&"
export * from "./error-book.vue?vue&type=script&lang=js&"
import style0 from "./error-book.vue?vue&type=style&index=0&id=ec134438&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec134438",
  null
  
)

export default component.exports